import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword, sendSignInLinkToEmail, sendPasswordResetEmail } from "firebase/auth";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AcctCreateService {
  constructor() { }
  async sendResetPassword(email: string) {
    const auth = getAuth();
    return sendPasswordResetEmail(auth, email)
      .catch((error) => {
        console.error("Reset password error:", error);
        throw error;
      });
  }

  async createAcct(email: string): Promise<boolean> {
    const allowedDomains = ["@gcpsK12.org", "@Gwinnettcb.org", "@gmail.com"]

    var isAllowed = allowedDomains.some(domain =>
      email.toLowerCase().endsWith(domain.toLowerCase())
    );

    isAllowed = true;
    if (!isAllowed) {
      alert("Email domain is not allowed");
      return false;
    }

    const auth = getAuth();
    const actionCodeSettings = {
      url: `https://${environment.firebase.deploymentId}.web.app/register`,
      handleCodeInApp: true,
    };

    try {
      console.log(actionCodeSettings);
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem('emailForSignIn', email);
      return true;
    } catch (error) {
      console.log(error);
      console.log((error as Error).message);
      return false;
    }
  }

  async submitAcct( title: string, firstName: string,
    lastName: string,
    role: string,
    middleInit: string,
    grade: string | null,
    school: string | null,
    email: string,
    password: string,
    passwordConf: string
  ) {
    try {
      const auth = getAuth();
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await firebase.firestore().collection('teacher').doc(user.uid).set({
        img: 'gs://greenhealthyschools-e3fa8.appspot.com/profileImgs/teacher.jpg',
        title,
        fName: firstName,
        mInitial: middleInit,
        lName: lastName,
        email,
        school,
        grade,
        bio: '',
        projs: [],
        role,
        isActive: true
      });
      return true;
    } catch (error: any) {
      if (error.code === 'auth/email-already-in-use') {
        alert('This email is already registered.');
      } else {
        alert('Something went wrong. Try again.');
      }
      console.error('Firebase signup error:', error.message);
      return false;
    }
  }
}
